'use client';

import { useEffect } from 'react';

export function ConsoleSignature() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if ((window as any).__TRY_DIG_CONSOLE_SIGNATURE_LOGGED__) return;
      (window as any).__TRY_DIG_CONSOLE_SIGNATURE_LOGGED__ = true;
    }

    const asciiLogo = [
      '████████╗██████╗ ██╗   ██╗ ███████╗ ██████╗  ██████╗ ███╗   ███╗',
      '╚══██╔══╝██╔══██╗╚██╗ ██╔╝ ██╔════╝██╔════╝ ██╔═══██╗████╗ ████║',
      '   ██║   ██████╔╝ ╚████╔╝  █████╗  ██║      ██║   ██║██╔████╔██║',
      '   ██║   ██╔══██╗  ╚██╔╝   ██╔══╝  ██║      ██║   ██║██║╚██╔╝██║',
      '   ██║   ██║  ██║   ██║    ███████╗╚██████╗ ╚██████╔╝██║ ╚═╝ ██║',
      '   ╚═╝   ╚═╝  ╚═╝   ╚═╝    ╚══════╝ ╚═════╝  ╚═════╝ ╚═╝     ╚═╝',
    ].join('\n');

    const text =
      "═════════════════ Proudly developed by Try eCom.════════════════\n\nCareer opportunities: https://try.no/karriere ";

    console.log(
      '%c' + asciiLogo + '\n\n' + text,
      [
        'font-family: monospace',
        'line-height: 1.2',
      ].join('; ')
    );
  }, []);

  return null;
}
